import { render, staticRenderFns } from "./beaconAdmin.vue?vue&type=template&id=cac89e82&scoped=true&"
import script from "./beaconAdmin.vue?vue&type=script&lang=js&"
export * from "./beaconAdmin.vue?vue&type=script&lang=js&"
import style0 from "./beaconAdmin.vue?vue&type=style&index=0&id=cac89e82&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cac89e82",
  null
  
)

export default component.exports